import {TemplateRef} from '@angular/core';
import {ContextType} from "../Helpers/Context";

export interface JBMTableFilter { key: string, value: string }
export interface JBMTableDisplayValue { dataValue: any, displayValue: string, className?: string }

export enum JBMTableColumnType {
  id = 0,                 // Unique row-id or record id
  string = 1,
  number = 2,
  date = 3,               // dd-mm-yyyy
  dateshort = 4,          // dd-mm
  time = 5,               // hh:mm
  timeseconds = 6,        // hh:mm:ss
  datetime = 7,           // dd-mm-yyyy hh:mm
  datetimeseconds = 8,    // dd-mm-yyyy hh:mm:ss
  boolean = 9,
  price = 10,
  email = 11,
  notes = 12,
  address = 13,
  custom = 14,
  stringAndID = 15,
  panelToggle = 16,
}

export enum JBMTableColumnAlignment { left, center, right }

export interface JBMTableColumnDef {
  name: string;
  header?: string;
  type?: JBMTableColumnType;
  sortable?: boolean;
  sorted?: boolean;
  visible?: boolean;
  hideable?: boolean;
  filterable?: boolean;
  searchMinLength?: number;
  filterValues?: JBMTableFilter[],
  displayValues?: JBMTableDisplayValue[],
  filterValue?: string,
  width?: number;
  minWidth?: number;
  maxWidth?: number;
  align?: JBMTableColumnAlignment;
  template?: TemplateRef<any>;
  className?: string;
  iconClassname?: string;
  moveable?: boolean;
  sizeable?: boolean;
  IDName?: string;
  tag?: any;
}

export interface JBMTableActionDef {
  name: string;
  context?: ContextType;
  iconClass?: string;
  caption?: string;
  disabled?: boolean;
}

export interface JBMTableColumnSortEvent {
  name: string;
  descending: boolean;
}

export interface JBMTableColumnFilterEvent {
  name: string;
  value: any;
}

export interface JBMTableActionClickEvent {
  name: string;
  row: any;
}

// Display setting for columnType = stringAndID
export enum StringIDdisplay { none=0, displayIdAfter=1, displayIdBefore=2 }
